import React from "react";

import { FileData } from "../../../../util/interfaces/FileData";

interface StepThreeProps {
  files: FileData[];
}
const StepThree: React.FC<StepThreeProps> = ({ files }) => {
  return (
    <div data-testid="stepThree">
      <div className="display-files-uploaded flex flow-column">
        <div className="step-three-details">
          <div className="table-header">
            <div className="file_table_cell selected_files_header">Selected files</div>
            <div className="file_table_cell category_header">Category</div>
          </div>
          {files.map((f) => (
            <div className="flex gap-5" key={`fileStepThree-${f.file.name}`}>
              <span
                title={f.file.name}
                className="text-overflow-ellipsis"
                style={{
                  width: "80%",
                }}
              >
                {f.file.name}
              </span>
              <div className=" category_header">{f.fileCategory}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StepThree;
